<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">table_chart</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Tabela de alíquota CBS</h2>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    @if (isLoading) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <div class="desktop-view">
    <table mat-table [dataSource]="linhas" class="w-100">
        <ng-container matColumnDef="aliquota">
            <th mat-header-cell *matHeaderCellDef>Alíquota</th>
            <td mat-cell *matCellDef="let row">
                <span class="status-badge" [class.badge-azul]="row.personalizada" [class.badge-cinza]="!row.personalizada">
                    {{ row.pAliquota }}%
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="vigencia">
            <th mat-header-cell *matHeaderCellDef>Período de vigência</th>
            <td mat-cell *matCellDef="let row" class="text-secondary" style="font-size:0.85rem;">
                {{ row.dataVigenciaInicio ? (row.dataVigenciaInicio | date:'dd/MM/yyyy') : '-' }} - {{ row.dataVigenciaFim ? (row.dataVigenciaFim | date:'dd/MM/yyyy') : 'Permanente' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
            <td mat-cell *matCellDef="let row" class="text-center">
                <button mat-icon-button class="btn-spinner" [class.btn-loading]="isSalvando" [disabled]="isSalvando"
                    [matMenuTriggerFor]="menu" [attr.aria-label]="isSalvando ? 'Salvando' : 'Ações'">
                    <span class="material-symbols-outlined">more_horiz</span>
                    @if (isSalvando) { <mat-spinner diameter="20"></mat-spinner> }
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="editar(row)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    </div>

    <div class="mobile-view">
        @for (row of linhas; track row.dataVigenciaInicio) {
        <div class="card-mobile mb-3">
            <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <span class="status-badge" [class.badge-azul]="row.personalizada" [class.badge-cinza]="!row.personalizada">{{ row.pAliquota }}%</span>
                <button mat-icon-button class="btn-spinner" [class.btn-loading]="isSalvando" [disabled]="isSalvando"
                    [matMenuTriggerFor]="menuMobCbs" [attr.aria-label]="isSalvando ? 'Salvando' : 'Ações'">
                    <span class="material-symbols-outlined">more_horiz</span>
                    @if (isSalvando) { <mat-spinner diameter="20"></mat-spinner> }
                </button>
                <mat-menu #menuMobCbs="matMenu">
                    <button mat-menu-item (click)="editar(row)">
                        <span class="material-symbols-outlined">edit</span>
                        <span>Editar</span>
                    </button>
                </mat-menu>
            </div>
            <div class="card-body-mobile p-3">
                <p class="mb-0">
                    <strong>Período de vigência:</strong>
                    {{ row.dataVigenciaInicio ? (row.dataVigenciaInicio | date:'dd/MM/yyyy') : '-' }} - {{ row.dataVigenciaFim ? (row.dataVigenciaFim | date:'dd/MM/yyyy') : 'Permanente' }}
                </p>
            </div>
        </div>
        }
    </div>

    @if (linhas.length === 0) {
    <app-empty-state
        icon="search_off"
        title="Nenhuma alíquota vigente"
        subtitle="Não há alíquota da CBS vigente hoje na Tabela Global.">
    </app-empty-state>
    }
    }
</mat-dialog-content>
